export default function HealthResourcesDirective() {
  return {
    template: require('./health-resources.html'),
    scope: {
      assessmentId: '=',
      status: '@',
    },
    controller: 'HealthResourcesController',
    controllerAs: 'healthResourcesVM',
    bindToController: true,
    replace: true,
  };
}
